import React from 'react';
import p1 from '../../Media/card1/p1.png'
import p2 from '../../Media/card1/p2.png'
import p3 from '../../Media/card1/p3.png'
import p4 from '../../Media/card1/p4.png'
import p5 from '../../Media/card1/p5.png'
import p6 from '../../Media/card1/p6.png'

const Sec8 = () => {
    return (
        <div className='text-center bg-gray-100 py-16 md:py-28'>
            <h1 className='text-3xl md:text-6xl font-extrabold'>Messenger APP</h1>
            <p className='text-xl mt-3 text-gray-600 md:w-6/12 w-11/12 mx-auto'>New communication app which allows you to make FREE voice calls and
                send FREE messages whenever and wherever you are, 24 hours a day!
            </p>
            <div className='w-10/12 mx-auto grid grid-cols-12 mt-10 gap-5'>
                <div className='text-center col-span-12 md:col-span-6 lg:col-span-4'>
                    <div className='flex justify-center'>
                        <img src={p1} alt="" />
                    </div>
                    <h3 className='text-3xl font-bold my-3'>Texts, Voice & Video Calls</h3>
                    <p className='text-gray-600'>You can send one-on-one and group texts, and use international voice and video calls with your friends.</p>
                </div>
                <div className='text-center col-span-12 md:col-span-6 lg:col-span-4'>
                    <div className='flex justify-center'>
                        <img src={p2} alt="" />
                    </div>
                    <h3 className='text-3xl font-bold my-3'>Stickers, Emoji, Themes</h3>
                    <p className='text-gray-600'>You can share you feelings with stickers or emoji, and wrap your app with colorful themes</p>
                </div>
                <div className='text-center col-span-12 md:col-span-6 lg:col-span-4'>
                    <div className='flex justify-center'>
                        <img src={p3} alt="" />
                    </div>
                    <h3 className='text-3xl font-bold my-3'>OpenChat</h3>
                    <p className='text-gray-600'>You can meet new friends with similar interests and share fun news and information.</p>
                </div>
                <div className='text-center col-span-12 md:col-span-6 lg:col-span-4'>
                    <div className='flex justify-center'>
                        <img src={p4} alt="" />
                    </div>
                    <h3 className='text-3xl font-bold my-3'>Hometab</h3>
                    <p className='text-gray-600'>You can access to various information, services, contents like LINE family services, stickers, etc.</p>
                </div>
                <div className='text-center col-span-12 md:col-span-6 lg:col-span-4'>
                    <div className='flex justify-center'>
                        <img src={p5} alt="" />
                    </div>
                    <h3 className='text-3xl font-bold my-3'>LINE VOOM</h3>
                    <p className='text-gray-600'>Explore even more content that you may like in the "For you" tab.</p>
                </div>
                <div className='text-center col-span-12 md:col-span-6 lg:col-span-4'>
                    <div className='flex justify-center'>
                        <img src={p6} alt="" />
                    </div>
                    <h3 className='text-3xl font-bold my-3'>Wallet</h3>
                    <p className='text-gray-600'>Paying or sending money by "LINE Pay", and you can use various LINE financial services.</p>
                </div>
            </div>
        </div>
    );
};

export default Sec8;